import { useState, FocusEvent, ChangeEvent, useCallback } from 'react';
import { InputControlProps } from 'app/components/Controls/InputControl/InputControl.interfaces';

export function useInputControl({
  input,
  onValueChange,
  onControlBlur,
  onClick,
  shouldRunOnChanges,
  maxLength,
}: InputControlProps) {
  const [focused, setFocused] = useState(false);

  const handleFocus = useCallback((value: string) => {}, []);

  const onFocus = useCallback(
    (e: FocusEvent<HTMLInputElement>) => {
      handleFocus(e.target.value);
      setFocused(true);
    },
    [handleFocus]
  );

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (maxLength && event.target.value.length > maxLength) return;

      input.onChange(event.target.value);

      if (onValueChange) {
        onValueChange(event.target.value, false, false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [input.onChange, onValueChange]
  );

  const handleBlur = useCallback(
    (event: FocusEvent<HTMLInputElement>) => {
      setFocused(false);

      input.onBlur(event.target.value.trim());

      if (onControlBlur) {
        onControlBlur();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [input.onBlur, onControlBlur]
  );

  const handleClick = useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  return {
    focused,
    onFocus,
    handleChange,
    handleBlur,
    handleClick,
  };
}
